module.exports = __webpack_public_path__ + "static/media/TV.88841959.png";